import { Box, Container, Grid, Typography } from "@mui/material";

const Privacy = () => {
  return (
    <Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
      <Container>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: "red",
          }}
        >
          Privacy <span style={{ color: "#FAD707" }}>Policy</span>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: "left",
            fontWeight: "500",
            color: "#333",
            mt: 2,
          }}
        >
          Our Privacy Policy explains how we collect, use, and protect your personal information. We are committed to maintaining your 
          privacy and ensuring data security. Please review the policy to understand your rights and our practices.
        </Typography>

        <Grid container spacing={4} sx={{ mt: 1 }}>
          {/* 📍 General Terms */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ textAlign: "left", fontWeight: "bold", mb: 1 }}>
            Privacy Statement
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "left", color: "#444" }}>
            THIRUKADAIYUR SENAITHALAIVAR CHARITABLE Trust is dedicated to safeguarding the privacy of all website users. Information collected, 
            including your name, email, and donation details, is kept confidential, securely stored, and shared only with third parties as necessary to process donations. Emails may be used to send donation receipts or newsletters, with an option to opt out.
            <br /><br />
            The Trust does not assume responsibility for damage or loss caused by third-party misuse of personal information. 
            Security measures include robust systems like secure servers and encryption to protect your personal data from unauthorized access, misuse, or disclosure.
            </Typography>
            
          </Grid>

          {/* 📍 Privacy Assurance */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ textAlign: "left", fontWeight: "bold", mb: 1 }}>
            Disclaimer of Liability
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "left", color: "#444" }}>
            THIRUKADAIYUR SENAITHALAIVAR CHARITABLE Trust does not assume responsibility for any damage or loss resulting
             from the misuse of personal information by third parties, and users are encouraged to exercise caution when
              sharing personal details online.
            </Typography>
          </Grid>

          {/* 📍 Content Ownership */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ textAlign: "left", fontWeight: "bold", mb: 1 }}>
            Security Measures
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "left", color: "#444" }}>
            Secure servers and encryption of sensitive information are employed to safeguard personal data.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Privacy;